/*
 * Copyright (c) 2019. World Wide Generation Ltd
 */

import { ChangeDetectionStrategy, Component, HostListener, Inject, Input } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

interface ConfirmData {
  text: string;
  title: string;
  confirmText: string;
}

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'wwg-confirm-dialog',
  templateUrl: './confirm-dialog.component.html',
  styleUrls: ['./confirm-dialog.component.scss']
})
export class ConfirmDialogComponent {

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: ConfirmData,
    private mdDialogRef: MatDialogRef<ConfirmDialogComponent>,
  ) { }

  public cancel() {
    this.mdDialogRef.close(false);
  }

  public confirm() {
    this.mdDialogRef.close(true);
  }

  @HostListener('keydown.esc')
  public onEsc() {
    this.mdDialogRef.close(false);
  }
}
